/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'fabric.editor.headingLink.ascSortingLabel': '遞增',
  'fabric.editor.headingLink.copied': '已複製！',
  'fabric.editor.headingLink.copyAnchorLink': '複製標題連結',
  'fabric.editor.headingLink.copyAriaLabel': '複製',
  'fabric.editor.headingLink.descSortingLabel': '遞減',
  'fabric.editor.headingLink.failedToCopy': '複製失敗',
  'fabric.editor.headingLink.noneSortingLabel': '無',
  'fabric.editor.inlineComment.marker.end': '內嵌留言結束',
  'fabric.editor.inlineComment.marker.start': '內嵌留言開始',
};
